import AppImage from '@theme/components/atom/AppImage'
import AppTitle from '@theme/components/atom/AppTitle'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  mixins: [HeadingLevel],
  components: {
    AppImage,
    AppTitle,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    imagePosition: {
      type: String,
      default() {
        return this.$themeSettings.components.ArticleTeaser.image.position
      },
    },
    lazyImage: {
      type: Boolean,
      default: false,
    },
  },
}
